import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CompanyInfoPage.IntegrationSection', {
    title: 'Accounting Software',
    connectedNotificationMessage: 'The Organisation is connected to {integrationName}.',
    sectionHeader: 'Accounting software',
});
